module.exports = __webpack_public_path__ + "img/collect_ldl2.ba57e678.png";